import React, { useState, useEffect } from "react";
import { ref, onValue } from "firebase/database";
import { db } from "../firebase";
import { FaPlus, FaCircleNotch, FaUserCircle, FaUser } from "react-icons/fa";

function StatusList({ currentUser }) {
  const [stories, setStories] = useState({});
  const [users, setUsers] = useState({});

  useEffect(() => {
    // Fetch all users to map names/photos
    const usersRef = ref(db, "users");
    onValue(usersRef, (snapshot) => {
      setUsers(snapshot.val() || {});
    });

    // Fetch all stories
    const storiesRef = ref(db, "stories");
    onValue(storiesRef, (snapshot) => {
      setStories(snapshot.val() || {});
    });
  }, []);

  const storyEntries = Object.entries(stories).filter(([uid]) => uid !== currentUser.uid);

  return (
    <div className="sidebar-view status-view">
      <div className="sidebar-header">
        <h2>Status</h2>
        <div className="sidebar-header-actions">
          <FaPlus title="Add Status" />
        </div>
      </div>

      <div className="chat-list">
        {/* COMING SOON BANNER */}
        <div style={{ margin: '12px 14px 6px 14px', padding: '12px 14px', background: 'rgba(0, 168, 132, 0.1)', border: '1px solid rgba(0, 168, 132, 0.25)', borderRadius: '14px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <FaCircleNotch style={{ fontSize: '18px', color: '#00a884' }} />
            <div>
              <div style={{ fontWeight: '700', fontSize: '13px', color: 'var(--text-primary)' }}>24-Hour Status Stories</div>
              <div style={{ fontSize: '11px', color: 'var(--text-secondary)' }}>Share photos & status updates</div>
            </div>
          </div>
          <span style={{ background: '#00a884', color: 'white', fontSize: '10px', fontWeight: '800', padding: '3px 8px', borderRadius: '100px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Coming Soon</span>
        </div>

        {/* MY STATUS */}
        <div className="chat-item">
          <div className="avatar" style={{ border: '2px solid #00a884', padding: '2px' }}>
            {currentUser?.photoURL ? (
              <img src={currentUser.photoURL} alt="my status" />
            ) : (
              <FaUserCircle style={{ color: 'var(--icon-color)', fontSize: '30px' }} />
            )}
          </div>
          <div className="chat-item-content">
            <div className="chat-info">
              <div className="chat-top">
                <h4>My Status</h4>
              </div>
              <p className="preview">
                {stories[currentUser.uid] ? "Already updated" : "Tap to add status update"}
              </p>
            </div>
          </div>
        </div>

        <div className="section-divider" style={{ padding: '15px', fontSize: '14px', color: '#00a884', fontWeight: 'bold', background: 'transparent' }}>
          RECENT UPDATES
        </div>

        {storyEntries.length > 0 ? (
          storyEntries.map(([uid, story]) => {
            const user = users[uid] || {};
            return (
              <div className="chat-item" key={uid}>
                <div className="avatar" style={{ border: '2px solid #00a884', padding: '2px' }}>
                  {user.photoURL ? (
                    <img src={user.photoURL} alt={user.name} />
                  ) : (
                    <div style={{ width: '100%', height: '100%', background: '#ccc', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontWeight: 'bold' }}>
                      <FaUser style={{fontSize: '24px', opacity: 0.7}} />
                    </div>
                  )}
                </div>
                <div className="chat-item-content">
                  <div className="chat-info">
                    <div className="chat-top">
                      <h4>{user.name || "Unknown User"}</h4>
                    </div>
                    <p className="preview">
                      {new Date(story.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                    </p>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div style={{ padding: '40px', textAlign: 'center', color: 'var(--text-secondary)', fontSize: '14px' }}>
            No recent updates found.
          </div>
        )}
      </div>
    </div>
  );
}

export default StatusList;
